"use client";

import { c as _c } from "react/compiler-runtime";
import { useStytchMember } from "@stytch/nextjs/b2b";
import { createContext, useContext, type ReactNode } from "react";
import { useGroupContext } from "@/src/lib/data-fetchers/group-fetchers";
import type { Group } from "@/src/models/group";
interface UserContextProps {
  email: string | null;
  stytchOrgId: string | null;
  group: Group | null;
  groups: Group[];
  tenancy: string | null;
  roles: string[];
}
const UserContext = createContext<UserContextProps | undefined>(undefined);
const EMPTY_USER_CONTEXT: UserContextProps = {
  email: null,
  stytchOrgId: null,
  group: null,
  groups: [],
  tenancy: null,
  roles: []
};
export const UserProvider = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const {
    member
  } = useStytchMember();
  const {
    data: groupContext
  } = useGroupContext(member?.organization_id);
  const group = groupContext?.group ?? null;
  const isReady = Boolean(member && group);
  const t1 = isReady ? member?.email_address ?? null : null;
  const t2 = isReady ? member?.organization_id ?? null : null;
  let t3;
  if ($[0] !== groupContext?.groups) {
    t3 = groupContext?.groups ?? [];
    $[0] = groupContext?.groups;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = group?.tenancy ?? null;
  let t5;
  if ($[2] !== isReady || $[3] !== member?.roles) {
    t5 = isReady ? member?.roles?.map(_temp) ?? [] : [];
    $[2] = isReady;
    $[3] = member?.roles;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== group || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      email: t1,
      stytchOrgId: t2,
      group,
      groups: t3,
      tenancy: t4,
      roles: t5
    };
    $[5] = group;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const userState = t6;
  let t7;
  if ($[12] !== children || $[13] !== userState) {
    t7 = <UserContext.Provider value={userState}>{children}</UserContext.Provider>;
    $[12] = children;
    $[13] = userState;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
function _temp(role) {
  return role.role_id;
}